import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import * as campaignApis from "../../utilities/apis/campaign"
import Layout from "../../components/Layout"
import Pagination from "../../components/Pagination"

const Campaigns = () => {
  const { token, permissions } = useSelector(state => state.user)
  const [campaigns, setCampaigns] = useState([])
  const [active, setActive] = useState(1)
  const nameRef = useRef(null)
  const [filters, setFilters] = useState({
    offset: 0,
    limit: 10,
  })

  const handleSearch = () => {
    const where = {}

    if (nameRef.current.value) where.name = nameRef.current.value

    setFilters({ limit: filters.limit, offset: 0, ...where })
    setActive(1)
  }

  const handleReset = () => {
    setFilters({ limit: 10, offset: 0 })
    nameRef.current.value = ''
    setActive(1)
  }

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await campaignApis.deleteCampaign(token, id)
      if (!response.status) throw new Error(response.message)

      setCampaigns((previous) => {
        const campaigns = previous.filter(x => x.id !== id)
        return [...campaigns]
      })
    } catch (error) {
      alert(error.message)
    }
  }

  const getCampaigns = async () => {
    try {
      const response = await campaignApis.getCampaigns(token, "")
      if (!response.status) throw new Error(response.message)

      setCampaigns(response.campaigns)
    } catch (error) {
      alert(error.message)
    }
  }

  const handlePageChange = (page, offset) => {
    setFilters({ ...filters, offset })
    setActive(page)
  }

  useEffect(() => {
    getCampaigns()
  }, [])

  const filtered = filters.name
    ? campaigns.filter(x => x.name && x.name.toLowerCase().includes(filters.name.toLowerCase()))
    : campaigns
  const rows = filtered.slice(filters.offset, filters.offset + filters.limit)

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="w-75 mx-auto">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Campaigns</p>
            <div className="d-flex gap-2">
              {permissions["CREATE_CAMPAIGN"] && <Link to="/dashboard/campaign" className="btn btn-theme rounded-4">New</Link>}
            </div>
          </div>

          <div className="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="row">
                <div className="col-md-2">
                  <input ref={nameRef} type="text" className="form-control form-control-sm rounded-3" id="name" placeholder="Name" required />
                </div>
                <div className="col-md-8" />
                <div className="col-md-2">
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleSearch}><i className="fas fa-search me-2"></i> Search</button>
                    <button type="reset" className="btn btn-sm btn-light-danger rounded-3" onClick={handleReset}><i className="fas fa-times me-2"></i> Clear</button>
                  </div>
                </div>
              </div>
            </div>
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "20%" }} className="align-middle">Name</th>
                  <th scope="col" style={{ width: "50%" }} className="align-middle">Message</th>
                  <th scope="col" style={{ width: "20%" }} className="align-middle">Progress</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => {
                  const total = row.campaign_lineitems.length
                  const sent = total ? row.campaign_lineitems.filter(item => item.sent).length / total * 100 : 0
                  const responded = total ? row.campaign_lineitems.filter(item => item.responded).length / total * 100 : 0

                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle">{row.name}</td>
                      <td className="align-middle">{row.message}</td>
                      <td className="align-middle">
                        <div className="progress" style={{ height: "8px" }}>
                          <div className="progress-bar bg-success" role="progressbar" style={{ width: `${responded}%` }} aria-valuenow={(responded).toString()} aria-valuemin="0" aria-valuemax="100"></div>
                          <div className="progress-bar bg-warning" role="progressbar" style={{ width: `${sent - responded}%` }} aria-valuenow={(sent).toString()} aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex gap-2 justify-content-center">
                          {permissions["UPDATE_CAMPAIGN"] && <Link to={`/dashboard/campaign?id=${row.id}`}><i className="far fa-clipboard"></i></Link>}
                          {permissions["DELETE_CAMPAIGN"] && <a className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <nav aria-label="pagination">
            <Pagination
              currentPage={active}
              totalCount={filtered.length}
              pageSize={filters.limit}
              offset={filters.offset}
              siblingCount={3}
              onPageChange={handlePageChange}
            />
          </nav>
        </div>
      </main>
    </Layout>
  )
}

export default Campaigns
